import { InputHelpText } from '@/components/ui/input-help-text'
import { Label } from '@/components/ui/label'
import { type TKey, useTranslation } from '@/translations/i18n'

/** Shared column sizing for side-by-side form fields. */
export const COLUMN_WIDTH = 'min-w-0 flex-1'

/** Resolves a form field's i18n error key to its message. */
export function useErrorText() {
	const { t } = useTranslation()
	return (key?: string) => (key ? t(key as TKey) : undefined)
}

/** Appends a red asterisk marking a field as required. */
export function RequiredLabel({ label }: { label: string }) {
	return (
		<>
			{label} <span className='text-danger-500'>*</span>
		</>
	)
}

/** Field wrapper: label above, control, then an inline error message. */
export function Field({
	id,
	label,
	required,
	error,
	className,
	children
}: {
	id?: string
	label: string
	required?: boolean
	error?: string
	className?: string
	children: React.ReactNode
}) {
	return (
		<div className={`flex flex-col gap-1.5 ${className ?? ''}`}>
			<Label htmlFor={id}>
				{required ? <RequiredLabel label={label} /> : label}
			</Label>
			{children}
			<InputHelpText error={error} />
		</div>
	)
}
